var _rect, _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 193,
    viewBox: "0 0 221 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 82.0178,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1696_41898)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 51.3227C105.039 49.8193 110.247 49.7821 115.14 51.2157L201.676 76.5645C207.399 78.241 207.437 86.3351 201.729 88.0647L115.378 114.232C110.337 115.759 104.95 115.72 99.9323 114.118L18.214 88.0381C12.618 86.2521 12.6564 78.3204 18.2695 76.5888L100.166 51.3227Z",
    fill: "#3D3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1696_41898)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 80.0178,
    rx: 26.5,
    ry: 2,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.562 18.3437C123.531 16.2187 124.531 6.25 110.5 6.25L81 37.5C84.75 53.0625 94.1563 61.7812 110.5 68.75L140 37.5C140.906 33.7187 141.469 29.5625 141.75 24.9062C141.906 21.75 139.687 18.875 136.562 18.3437Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 6.25V37.5H81C80.0937 33.7187 79.5312 29.5625 79.25 24.9062C79.0937 21.75 81.3125 18.875 84.4375 18.3437C97.4687 16.2187 96.4687 6.25 110.5 6.25Z",
    fill: "url(#paint1_linear_1696_41898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140 37.5C136.25 53.0625 126.844 61.7812 110.5 68.75V37.5H140Z",
    fill: "url(#paint2_linear_1696_41898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1696_41898",
    x: 69,
    y: 64.0178,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1696_41898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1696_41898",
    x1: 206,
    y1: 137.018,
    x2: 14,
    y2: 137.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1696_41898",
    x1: 94.8711,
    y1: 6.25,
    x2: 94.8711,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#4671F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1696_41898",
    x1: 125.25,
    y1: 37.5,
    x2: 125.25,
    y2: 68.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#4671F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationDark);
export default __webpack_public_path__ + "static/media/illustration-dark.a43dc6d1593548a3412160c8164f339d.svg";
export { ForwardRef as ReactComponent };